import { __assign } from "tslib";
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React, { useContext } from 'react';
import Image from './Image';
import MobileImage from './MobileImage';
export var ImageFullViewWrapper = function (props) {
    var isMobile = useContext(MobileContext);
    var lcp2 = useFlag('lcp2');
    if (lcp2 && isMobile) {
        return React.createElement(MobileImage, __assign({}, props));
    }
    return React.createElement(Image, __assign({}, props));
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;
//# sourceMappingURL=index.js.map